import React, { Component } from 'react'
import './DeviceHistory.css'
import * as languageSettings from '../Language/languageSettings'
import { connect } from 'react-redux'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import Pagination from '../Common/Pagination'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
// import whiteplus from '../../images/whiteplus.png'
import Api from '../../Api'
import { sortUsers } from '../../actions/users'
import { getDeviceHistoryList } from '../../actions/devicehistorylist'
import * as ReactBootstrap from 'react-bootstrap'
// import Search from '../images/search.jpg'
import AuthenticationService from '../Security/AuthenticationService'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import CommonLoader from '../Alerts/CommonLoader'

class DeviceHistory extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      Ascending: true,
      offset: 0,
      data: [],
      recordCount: 10,
      filter: '',
      page: 0,
      showCommonLoader: false,
      search: '',
      sc: 'Task_UID',
      st: 1,
      norecords: false,
      perPage: 10,
      sortType: 'ASC',
      isValid: true,
      errorMessage: [],
      show: false,
      popupData: []
    }
    this.api = new Api()
    this.PageSizeValueDropdown = this.PageSizeValueDropdown.bind(this)
    this.PageClicked = this.PageClicked.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
  }

  componentWillMount () {
    this.setState({ showCommonLoader: true })
    this.props.getDeviceHistoryList(this.state, function (accountData) {
      this.setState({
        showCommonLoader: false,
        recordCount: accountData[0].Total
      })
    }.bind(this))
  }

  popupThis (e, account) {
    let data = account.Task_UID
    const url = Config.apiBaseUrl + CommonConstants.apiUrls.getSettingHistoryInfo + '?taskUid=' + data
    this.api.getData(url, data => {
      if (data.status) {
        this.setState({ show: true, popupData: data.data, saveSuccess: true, showCommonLoader: false })
      } else {
        let errors = []
        errors.push('Something went wrong')
        this.setState({
          errors: errors,
          showCommonLoader: false
        })
      }
    })
  }

  popupClose (e) {
    this.setState({
      show: false
    })
  }
  cancelPremiumPopHide (e) {
    this.setState({
      show: false
    })
  }

  PageSizeValueDropdown (perPage) {
    this.setState({
      perPage,
      showCommonLoader: true
    })
    let input = this.state
    input.perPage = perPage !== 0 ? perPage : 20000000
    input.page = 1
    input.offset = 0
    this.props.getDeviceHistoryList(input, function (accountData) {
      if (accountData.length) {
        this.setState({
          showCommonLoader: false,
          recordCount: accountData[0].Total,
          offset: 0,
          page: 1
        })
      } else {
        this.setState({
          showCommonLoader: false,
          norecords: true,
          recordCount: 0
        })
      }
    }.bind(this))
    // this.state.offset = Math.ceil((this.state.offset / 10) * pageSize)
    this.state.offset = 0
  }

  PageClicked (value) {
    let input = this.state
    let pageNumber = (value / this.state.perPage) + 1
    this.setState({
      page: pageNumber,
      showCommonLoader: true
    })
    input.page = pageNumber
    this.props.getDeviceHistoryList(input, function (accountData) {
      this.setState({
        showCommonLoader: false,
        recordCount: accountData[0].Total
      })
    }.bind(this))
    if (value === null) {
      return this.state.offset
    } else {
      this.state.offset = value
      return this.state.offset
    }
  }

  sortAccounts (e) {
    let sc = e.target.id
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let input = this.state
    input.sc = e.target.id
    input.st = sortType === 'DESC' ? 0 : 1
    this.setState({
      showCommonLoader: true,
      sc: sc,
      sortType: sortType
    })
    this.props.getDeviceHistoryList(input, function (accountData) {
      this.setState({
        showCommonLoader: false,
        recordCount: accountData[0].Total,
        sc: sc,
        sortType: sortType
      })
    }.bind(this))
    this.state.Ascending = !this.state.Ascending
    this.setState(this.state)
  }

  renderUsers () {
    if (this.props.deviceHistoryList) {
      let storeRows = this.props.deviceHistoryList.deviceHistoryList.map(function (account, index) {
        return (
          <Tr className='tdata clear'>
            <Td className='view_details'>
              <a className='opener view_details' onClick={(e) => { this.popupThis(e, account) }}>
                <span translate='' key='viewedit'>View</span> <br />
                <span translate='' key='settingsStoresDetails'>Details</span>
              </a>
            </Td>
            <Td className='posRel'>{account.Task_UID}</Td>
            <Td>{moment(account.CreatedAt).format('MM/DD/YYYY')}</Td>
            <Td className='posRel'>
              {account.Store_Number.substring(0, 17)}
              <a className={'ellipse ' + (account.Store_Number.length > 17 ? '' : 'hide')}>
                  ...
                <span className='tooltipCustomAdmin'>{account.Store_Number}</span>
              </a>
            </Td>
            <Td>{account.LaneConfig_Name}</Td>
            <Td>{account.Device_MainVersion}</Td>
            <Td className='posRel'>
              {account.CreatedBy.substring(0, 17)}
              <a className={'ellipse ' + (account.CreatedBy.length > 17 ? '' : 'hide')}>
                ...
                <span className='tooltipCustomAdmin'>{account.CreatedBy}</span>
              </a>
            </Td>
          </Tr>
        )
      }.bind(this))
      return storeRows
    } else {
      return ''
    }
  }

  renderAddon () {
    let recordCount = this.state.recordCount
    let pageCount = Math.ceil(this.state.recordCount / this.state.perPage)
    let sortParams = this.state

    return (
      <div className='admin-accnt device-history'>
        <h3 className='clear'>Settings History</h3>
        <section className='users listingAdmin'>
          <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
          <div className={'settings forms' + (!this.state.showCommonLoader ? '' : 'hidden')}>
            <div className='settings_plug clear'>
              <div className='settings_list'>
                <div className='ctable'>
                  <Table>
                    <Thead>
                      <Tr className='theader clear'>
                        <Th />
                        <Th id='Task_UID' className={(sortParams.sc === 'Task_UID' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Task_UID' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Task_UID' onClick={(e) => { this.sortAccounts(e) }}>Task ID</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'CreatedAt' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'CreatedAt' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='CreatedAt' onClick={(e) => { this.sortAccounts(e) }}>Created At</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Store_Number' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Store_Number' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Store_Number' onClick={(e) => { this.sortAccounts(e) }}>Source Store Number</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'LaneConfig_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'LaneConfig_Name' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='LaneConfig_Name' onClick={(e) => { this.sortAccounts(e) }}>Lane Config</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Device_MainVersion' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Device_MainVersion' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Device_MainVersion' onClick={(e) => { this.sortAccounts(e) }}>Version</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'CreatedBy' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'CreatedBy' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='CreatedBy' onClick={(e) => { this.sortAccounts(e) }}>CreatedBy</span></a>
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody className={(this.state.norecords ? 'hide' : '')}>
                      {this.renderUsers()}
                    </Tbody>
                    <Tbody className={(this.state.norecords ? '' : 'hide')}>
                      <h2>No Records Found</h2>
                    </Tbody>
                  </Table>
                  <div>
                    <Pagination
                      perPage={this.state.perPage}
                      PageSizeValueChange={this.PageSizeValueDropdown}
                      offset={this.PageClicked}
                      recordCount={recordCount}
                      pageCount={pageCount}
                      offSetValue={this.state.offset}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {this.renderModal()}
      </div>
    )
  }

  renderModal () {
    let Modal = ReactBootstrap.Modal
    const listOption = () => {
      if (this.state.popupData.length) {
        return this.state.popupData.map(data => {
          return (
            <div className='row margin-zero'>
              <div className='col-xs-6 padding-zero'><span className='tv_row'>{data.Store_Number[1]}</span></div>
              <div className='col-xs-6 padding-zero'>
                <span className={'tv_row ' + (data.Status === 'COMPLETED ' ? 'success' : 'hide')}>{data.Status}</span>
                <span className={'tv_row ' + (data.Status === 'FAILED' ? 'failed' : 'hide')}>{data.Status}</span>
                <span className={'tv_row ' + (data.Status !== 'FAILED' && data.Status !== 'COMPLETED ' ? '' : 'hide')}>{data.Status}</span>
              </div>
            </div>
          )
        })
      }
    }
    const modalDetails = () => {
      if (this.state.popupData.length) {
        return (
          <div>
            <h3 className='title'>Task Details</h3>
            <div className='block'>
              <div className='row head'>
                <div className='left'><span>Task ID:</span></div>
                <div className='resposive-cust'><span id='taskId'>{this.state.popupData[0].Task_UID}</span></div>
              </div>
              <div className='row head'>
                <div className='left'><span>Create At:</span></div>
                <div className='resposive-cust'>
                  <span id='createdAt'>
                    {moment(this.state.popupData[0].CreatedAt).locale('en').format('MMMM D YYYY, h:mm:ss') }
                  </span>
                </div>
              </div>
              <div className='row head'>
                <div className='left'><span>Created By:</span></div>
                <div className='resposive-cust'><span id='createdBy'>{this.state.popupData[0].CreatedBy}</span></div>
              </div>
            </div>
            <div className=''>
              <div className='row'>
                <div className='col-sm-6'>
                  <h3 className='title'>Source Device information</h3>
                  <div className='block'>
                    <div className='row head'>
                      <div className='left'><span>Serial Number:</span></div>
                      <div className='resposive-cust'><span>{this.state.popupData[0].Device_SerialNumber}</span></div>
                    </div>
                    <div className='row head'>
                      <div className='left'><span>System Version:</span></div>
                      <div className='resposive-cust'><span>{this.state.popupData[0].Device_MainVersion}</span></div>
                    </div>
                    <div className='row head'>
                      <div className='left'><span>Lane Configuration:</span></div>
                      <div className='resposive-cust'><span>{this.state.popupData[0].LaneConfig_Name}</span></div>
                    </div>
                    <div className='row head'>
                      <div className='left'><span>Device Register to Store:</span></div>
                      <div className='resposive-cust'>
                        <span>
                          {this.state.popupData[0].Store_Name} {this.state.popupData[0].Store_AddressLine1}
                          {this.state.popupData[0].Store_Region}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-sm-6'>
                  <h3 className='title'>Settings Group Updated</h3>
                  <div className='block'>
                    <div className='row head'>
                      <div className='left'><span>Master Goal Group:</span></div>
                      <div><span id='taskId'>&nbsp;</span></div>
                    </div>
                    <div className='row head'>
                      <div className='left'><span>Lane Setting Group:</span></div>
                      <div><span>&nbsp;</span></div>
                    </div>
                    <div className='row head'>
                      <div className='left'><span>Daypart Goal Group:</span></div>
                      <div><span>&nbsp;</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='table-view'>
              <div className='row margin-zero'>
                <div className='col-xs-6 padding-zero'><span className='tv_header'>Destination Store #</span></div>
                <div className='col-xs-6 padding-zero'><span className='tv_header'>Status</span></div>
              </div>
            </div>
            <div className='table-body'>
              {listOption()}
            </div>
          </div>
        )
      }
    }

    return (
      <Modal show={this.state.show} dialogClassName='deviceHistoryModal' onHide={this.handleClose} >
        <Modal.Body className='popUpbody'>
          <div onClick={(e) => { this.popupClose(e) }} className='closer'>X</div>
          {modalDetails()}
        </Modal.Body>
      </Modal>
    )
  }

  render () {
    if (this.authService.isAdmin()) {
      return (
        <div className='reportsTabs'>
          {this.renderAddon()}
        </div>
      )
    } else {
      window.location.href = '/myAccount'
      return <div />
    }
  }
}
function mapStateToProps (state) {
  return {
    deviceHistoryList: state.devicehistorylist,
    users: state.users
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      sortUsers: sortUsers,
      getDeviceHistoryList
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(DeviceHistory)



// WEBPACK FOOTER //
// ./src/components/Device/DeviceHistory.js